import { useServerTranslation } from 'hooks/useServerTranslation';
import { z } from 'zod';

export function useRequiredBoolean() {
    const { t } = useServerTranslation();

    return (message: string) => z.literal(true, { errorMap: () => ({ message: t(message) }) });
}
